import axios from "axios";
import { ENDPOINTS } from "../api/endpoints";
import api from "../api/axios";

/**
 * Realiza la exclusion de la api
 * @param migrationId
 * @param xAccountId
 * @param apiId
 * @returns Retorna un boolean
 */
export async function excludeGenerate(migrationId: string, xAccountId: string, apiId: string) {
  try {
    const requestHeaders = {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    };

    const responseExclude = await api
      .post(
        ENDPOINTS.MIGRATION.POST_EXCLUDE_API(migrationId, apiId),
        { migrationId, apiId },
        {
          headers: requestHeaders,
        }
      )
      .then((res: any) => {
        return res.data;
      });

    return responseExclude;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorData = error.response?.data;
      return {
        success: false,
        status: error.response?.status || 500,
        error: {
          id: errorData?.data?.id || "unknown",
          code: errorData?.data?.code || "ERR_UNKNOWN",
          title: errorData?.data?.title || "Error",
          detail: errorData?.data?.detail || "Ocurrió un error al generar la exclusion",
        },
      };
    }

    return {
      success: false,
      status: 500,
      error: error instanceof Error ? error.message : "Ocurrió un error inesperado",
    };
  }
}
